// document.addEventListener('DOMContentLoaded', function () {
//   // Scroll reveal (fade + blur + rise) — ported from brahmaverse-one-website's <Reveal>
//   var revealEls = document.querySelectorAll('[data-ov-reveal]');
//   if (revealEls.length) {
//     if ('IntersectionObserver' in window) {
//       var revealObserver = new IntersectionObserver(function (entries) {
//         entries.forEach(function (entry) {
//           if (entry.isIntersecting) {
//             entry.target.classList.add('is-visible');
//             revealObserver.unobserve(entry.target);
//           }
//         });
//       }, { rootMargin: '0px 0px 220px 0px', threshold: 0.01 });
//       revealEls.forEach(function (el) { revealObserver.observe(el); });
//     } else {
//       revealEls.forEach(function (el) { el.classList.add('is-visible'); });
//     }
//   }

//   // Mobile nav toggle
//   document.querySelectorAll('[data-ov-nav-toggle]').forEach(function (toggle) {
//     var nav = toggle.closest('.ov-nav');
//     if (!nav) return;
//     toggle.addEventListener('click', function () {
//       var isOpen = nav.classList.toggle('is-menu-open');
//       toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
//     });
//     nav.querySelectorAll('.ov-nav__links a').forEach(function (link) {
//       link.addEventListener('click', function () {
//         nav.classList.remove('is-menu-open');
//         toggle.setAttribute('aria-expanded', 'false');
//       });
//     });
//   });

//   // Accordions (notes list + FAQ)
//   document.querySelectorAll('.ov-accordion__item').forEach(function (item) {
//     var trigger = item.querySelector('.ov-accordion__trigger');
//     if (!trigger) return;
//     trigger.addEventListener('click', function () {
//       var group = item.closest('[data-accordion-group]');
//       var exclusive = group && group.getAttribute('data-accordion-group') === 'single';
//       if (exclusive) {
//         group.querySelectorAll('.ov-accordion__item').forEach(function (sibling) {
//           if (sibling !== item) sibling.classList.remove('is-open');
//         });
//       }
//       item.classList.toggle('is-open');
//     });
//   });

//   // Variant option swatches -> update hidden variant id + price
//   document.querySelectorAll('[data-ov-option-value]').forEach(function (input) {
//     input.addEventListener('change', updateOvVariant);
//   });

//   function updateOvVariant() {
//     var form = document.getElementById('ov-product-form');
//     if (!form) return;
//     var script = form.closest('section').querySelector('script');
//     if (!script) return;
//     var match = script.textContent.match(/window\.ovProductVariants\[(.+?)\]\s*=\s*(\[.*\]);/s);
//     if (!match) return;
//     var variants;
//     try { variants = JSON.parse(match[2]); } catch (e) { return; }

//     var selected = [];
//     form.querySelectorAll('[data-ov-option-index]').forEach(function (group) {
//       var checked = group.querySelector('[data-ov-option-value]:checked');
//       if (checked) selected.push(checked.value);
//     });

//     var found = variants.find(function (v) {
//       var opts = [v.option1, v.option2, v.option3].filter(Boolean);
//       return selected.every(function (val, i) { return opts[i] === val; });
//     });
//     if (!found) return;

//     var idInput = document.getElementById('ov-variant-id');
//     if (idInput) idInput.value = found.id;

//     var priceEl = document.querySelector('[data-ov-price]');
//     if (priceEl && found.price != null) {
//       priceEl.textContent = (found.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD' });
//     }

//     var stickyPriceEl = document.querySelector('[data-ov-sticky-price]');
//     if (stickyPriceEl && found.price != null) {
//       stickyPriceEl.textContent = '₹' + Math.round(found.price / 100).toLocaleString('en-IN') + ' INR';
//     }
//   }

//   // Hero gallery thumbnails
//   document.querySelectorAll('[data-ov-thumb]').forEach(function (thumb) {
//     thumb.addEventListener('click', function () {
//       var gallery = thumb.closest('[data-ov-gallery]');
//       if (!gallery) return;
//       var mainImg = gallery.querySelector('[data-ov-main-image]');
//       var newSrc = thumb.getAttribute('data-full');
//       if (mainImg && newSrc) mainImg.src = newSrc;
//       gallery.querySelectorAll('[data-ov-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
//       thumb.classList.add('is-active');
//     });
//   });

//   // Hero v2 gallery prev/next arrows (no-op if a gallery has no arrows, e.g. the classic hero)
//   document.querySelectorAll('[data-ov-gallery]').forEach(function (gallery) {
//     var prevBtn = gallery.querySelector('[data-ov-gallery-prev]');
//     var nextBtn = gallery.querySelector('[data-ov-gallery-next]');
//     if (!prevBtn && !nextBtn) return;
//     var step = function (dir) {
//       var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ov-thumb]'));
//       if (!thumbs.length) return;
//       var activeIndex = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
//       var nextIndex = (activeIndex + dir + thumbs.length) % thumbs.length;
//       thumbs[nextIndex].click();
//       thumbs[nextIndex].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
//     };
//     if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
//     if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
//   });

//   // Hero v2: cap the thumbnail rail's height to match the main image's real
//   // rendered height (which varies with aspect-ratio + viewport width), so the
//   // rail scrolls internally instead of running on past the bottom of the image.
//   (function () {
//     var rails = document.querySelectorAll('.ov-hero2__rail');
//     if (!rails.length) return;
//     var sync = function () {
//       rails.forEach(function (rail) {
//         var stage = rail.parentElement && rail.parentElement.querySelector('.ov-hero2__stage');
//         if (!stage) return;
//         if (window.matchMedia('(max-width: 980px)').matches) {
//           rail.style.maxHeight = '';
//         } else {
//           rail.style.maxHeight = stage.offsetHeight + 'px';
//         }
//       });
//     };
//     sync();
//     window.addEventListener('resize', sync);
//     window.addEventListener('load', sync);
//     var mainImg = document.querySelector('.ov-hero2__main-image img');
//     if (mainImg && !mainImg.complete) mainImg.addEventListener('load', sync, { once: true });
//   })();

//   // Scroll-reveal heading — words dim→full opacity as the heading scrolls
//   // through the viewport (ported from brahmaverse-one-website's ScrollRevealHeading)
//   var scrollHeadings = document.querySelectorAll('[data-ov-scrollheading]');
//   if (scrollHeadings.length) {
//     var updateScrollHeadings = function () {
//       var vh = window.innerHeight;
//       scrollHeadings.forEach(function (h) {
//         var rect = h.getBoundingClientRect();
//         var p = (0.85 * vh - rect.top) / (0.5 * vh);
//         p = Math.max(0, Math.min(1, p));
//         var words = h.querySelectorAll('[data-ov-word]');
//         var n = words.length;
//         words.forEach(function (w, i) {
//           var start = i / n, end = (i + 1) / n;
//           var t = (p - start) / (end - start || 1);
//           t = Math.max(0, Math.min(1, t));
//           w.style.opacity = String(0.28 + t * 0.72);
//         });
//       });
//     };
//     window.addEventListener('scroll', updateScrollHeadings, { passive: true });
//     window.addEventListener('resize', updateScrollHeadings);
//     updateScrollHeadings();
//   }

//   // Ripple showcase — glass panels expand on hover/click, one open at a time
//   document.querySelectorAll('[data-ov-glass-group]').forEach(function (group) {
//     var panels = group.querySelectorAll('[data-ov-glass-panel]');
//     var openOne = function (panel) {
//       panels.forEach(function (p) { p.classList.toggle('is-open', p === panel); });
//     };
//     panels.forEach(function (panel) {
//       panel.addEventListener('mouseenter', function () { openOne(panel); });
//       panel.addEventListener('click', function () { openOne(panel); });
//     });
//   });

//   // Steps — scroll-pinned accordion (desktop). Section is 400vh tall; as the
//   // user scrolls through it, the active step (0..3) tracks scroll position and
//   // the phone screen cross-fades / device repositions to match.
//   var stepsSection = document.querySelector('[data-ov-steps]');
//   if (stepsSection) {
//     var stepTabs = stepsSection.querySelectorAll('[data-ov-step-tab]');
//     var stepScreens = stepsSection.querySelectorAll('[data-ov-step-screen]');
//     var stepDevice = stepsSection.querySelector('[data-ov-step-device]');
//     var stepPhone = stepsSection.querySelector('[data-ov-step-phone]');
//     var stepRipple = stepsSection.querySelector('[data-ov-step-ripple]');
//     var stepActive = 0;
//     var setStepActive = function (i) {
//       stepActive = i;
//       stepTabs.forEach(function (tab, idx) { tab.classList.toggle('is-open', idx === i); });
//       stepScreens.forEach(function (scr, idx) { scr.classList.toggle('is-visible', idx === i); });
//       if (stepPhone) stepPhone.style.opacity = i === 0 ? '0.32' : '1';
//       if (stepDevice) stepDevice.classList.toggle('is-behind', i !== 0);
//       if (stepRipple) stepRipple.style.opacity = i === 0 ? '1' : '0';
//     };
//     stepTabs.forEach(function (tab, idx) {
//       tab.addEventListener('click', function () { setStepActive(idx); });
//     });
//     var updateSteps = function () {
//       var rect = stepsSection.getBoundingClientRect();
//       var scrollable = rect.height - window.innerHeight;
//       var p = scrollable > 0 ? Math.max(0, Math.min(1, -rect.top / scrollable)) : 0;
//       var idx = Math.min(stepTabs.length - 1, Math.floor(p * stepTabs.length));
//       if (idx !== stepActive) setStepActive(idx);
//     };
//     window.addEventListener('scroll', updateSteps, { passive: true });
//     window.addEventListener('resize', updateSteps);
//     setStepActive(0);
//     updateSteps();
//   }

//   // Meet OneVerse — scroll-scrubbed device frame sequence pinned for 240vh
//   var meetSection = document.querySelector('[data-ov-meet]');
//   if (meetSection) {
//     var meetCanvas = meetSection.querySelector('[data-ov-meet-canvas]');
//     var meetHead = meetSection.querySelector('[data-ov-meet-head]');
//     var meetTitle = meetSection.querySelector('.ov-meet__title');
//     var meetSub = meetSection.querySelector('[data-ov-meet-sub]');
//     var meetWords = meetSection.querySelectorAll('[data-ov-meet-word]');
//     var FRAME_COUNT = 180, FRAME_W = 1080, FRAME_H = 2256, PAUSE_FRAME = 30;
//     var PLAY1_START = 0.06, PLAY1_END = 0.24, SUB_START = 0.26, SUB_END = 0.48,
//         RESUME_START = 0.5, RESUME_END = 0.92, EXIT_START = 0.82, EXIT_END = 0.94, HEAD_IN_END = 0.06;
//     var clamp01 = function (v) { return Math.max(0, Math.min(1, v)); };
//     var lerp = function (a, b, t) { return a + (b - a) * t; };
//     var frameFor = function (p) {
//       if (p <= PLAY1_START) return 0;
//       if (p < PLAY1_END) return Math.round(((p - PLAY1_START) / (PLAY1_END - PLAY1_START)) * PAUSE_FRAME);
//       if (p < RESUME_START) return PAUSE_FRAME;
//       var t = (p - RESUME_START) / (RESUME_END - RESUME_START);
//       return Math.round(PAUSE_FRAME + clamp01(t) * (FRAME_COUNT - 1 - PAUSE_FRAME));
//     };
//     var meetFramesScript = meetSection.querySelector('[data-ov-meet-frames]');
//     var meetFrameUrls = [];
//     try { meetFrameUrls = JSON.parse(meetFramesScript.textContent); } catch (e) { meetFrameUrls = []; }
//     var meetImgs = [];
//     for (var mi = 0; mi < FRAME_COUNT; mi++) {
//       var im = new Image();
//       im.decoding = 'async';
//       im.src = meetFrameUrls[mi] || '';
//       meetImgs.push(im);
//     }
//     var meetDraw = function (p) {
//       if (!meetCanvas || !meetCanvas.getContext) return;
//       var ctx = meetCanvas.getContext('2d');
//       if (!ctx) return;
//       var target = Math.min(FRAME_COUNT - 1, Math.max(0, frameFor(p)));
//       var img = meetImgs[target];
//       var ok = function (im) { return im && im.complete && im.naturalWidth > 0; };
//       if (!ok(img)) {
//         for (var d = 1; d < FRAME_COUNT; d++) {
//           if (ok(meetImgs[target - d])) { img = meetImgs[target - d]; break; }
//           if (ok(meetImgs[target + d])) { img = meetImgs[target + d]; break; }
//         }
//       }
//       if (!ok(img)) return;
//       var dpr = window.devicePixelRatio || 1;
//       var cw = meetCanvas.clientWidth, ch = meetCanvas.clientHeight;
//       if (meetCanvas.width !== Math.round(cw * dpr) || meetCanvas.height !== Math.round(ch * dpr)) {
//         meetCanvas.width = Math.round(cw * dpr);
//         meetCanvas.height = Math.round(ch * dpr);
//       }
//       ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
//       ctx.clearRect(0, 0, cw, ch);
//       var aspect = cw / ch;
//       var coverBias = aspect < 0.85 ? 0.32 : 0.55;
//       var scaleCover = cw / FRAME_W, scaleContain = ch / FRAME_H;
//       var scale = lerp(scaleContain, scaleCover, coverBias);
//       var drawW = FRAME_W * scale, drawH = FRAME_H * scale;
//       var dx = (cw - drawW) / 2;
//       var deviceFrac = p < RESUME_START ? 0.05 : lerp(0.05, 0.42, clamp01((p - RESUME_START) / (RESUME_END - RESUME_START)));
//       var dy = ch / 2 - deviceFrac * drawH;
//       dy = Math.max(Math.min(0, ch - drawH), dy);
//       ctx.drawImage(img, dx, dy, drawW, drawH);
//     };
//     var meetApplyText = function (p) {
//       var intro = clamp01(p / HEAD_IN_END);
//       var introEase = 1 - Math.pow(1 - intro, 3);
//       var exit = clamp01((p - EXIT_START) / (EXIT_END - EXIT_START));
//       if (meetHead) {
//         meetHead.style.opacity = String(intro * (1 - exit));
//         meetHead.style.transform = 'translate3d(0,' + (lerp(20, 0, introEase) - p * 22 - 140 * exit) + 'px,0)';
//       }
//       if (meetTitle) {
//         meetTitle.style.letterSpacing = lerp(0.18, -0.025, introEase) + 'em';
//         meetTitle.style.filter = 'blur(' + lerp(10, 0, introEase) + 'px)';
//       }
//       var span = (SUB_END - SUB_START) / meetWords.length;
//       meetWords.forEach(function (el, k) {
//         var start = SUB_START + k * span;
//         var t = clamp01((p - start) / (span * 1.5));
//         el.style.opacity = String(t);
//         el.style.transform = 'translate3d(0,' + lerp(12, 0, t) + 'px,0)';
//         el.style.filter = 'blur(' + lerp(6, 0, t) + 'px)';
//       });
//     };
//     var meetCompute = function () {
//       var rect = meetSection.getBoundingClientRect();
//       var scrollable = rect.height - window.innerHeight;
//       var p = scrollable > 0 ? clamp01(-rect.top / scrollable) : 0;
//       meetApplyText(p);
//       meetDraw(p);
//     };
//     var meetRaf = 0;
//     var meetOnScroll = function () {
//       cancelAnimationFrame(meetRaf);
//       meetRaf = requestAnimationFrame(meetCompute);
//     };
//     meetImgs.forEach(function (im) { im.onload = function () { meetDraw(progressNow()); }; });
//     function progressNow() {
//       var rect = meetSection.getBoundingClientRect();
//       var scrollable = rect.height - window.innerHeight;
//       return scrollable > 0 ? clamp01(-rect.top / scrollable) : 0;
//     }
//     window.addEventListener('scroll', meetOnScroll, { passive: true });
//     window.addEventListener('resize', meetOnScroll);
//     meetCompute();
//     setTimeout(meetCompute, 300);
//     setTimeout(meetCompute, 1000);
//   }

//   // Delay popup — opens automatically after N seconds
//   var delayPopup = document.querySelector('[data-ov-delaypopup]');
//   if (delayPopup) {
//     var popupSeenKey = 'ov-delaypopup-seen';
//     var frequency = delayPopup.getAttribute('data-once-per') || 'session';
//     var alreadySeen = false;
//     try { alreadySeen = window.sessionStorage.getItem(popupSeenKey) === '1'; } catch (e) {}

//     var openPopup = function () {
//       delayPopup.classList.add('is-open');
//       try { window.sessionStorage.setItem(popupSeenKey, '1'); } catch (e) {}
//     };
//     var closePopup = function () { delayPopup.classList.remove('is-open'); };

//     if (frequency === 'always' || !alreadySeen) {
//       var delaySeconds = parseFloat(delayPopup.getAttribute('data-delay-seconds')) || 15;
//       setTimeout(openPopup, delaySeconds * 1000);
//     }

//     delayPopup.querySelectorAll('[data-ov-delaypopup-close]').forEach(function (el) {
//       el.addEventListener('click', closePopup);
//     });
//     document.addEventListener('keydown', function (e) {
//       if (e.key === 'Escape' && delayPopup.classList.contains('is-open')) closePopup();
//     });

//     // Step 1 (question) -> step 2 (email form), tagging the pick onto the submission
//     var goToForm = function (answerLabel) {
//       var questionStep = delayPopup.querySelector('[data-ov-popup-step="question"]');
//       var formStep = delayPopup.querySelector('[data-ov-popup-step="form"]');
//       if (questionStep) questionStep.classList.remove('is-active');
//       if (formStep) formStep.classList.add('is-active');
//       if (answerLabel) {
//         var tagsInput = delayPopup.querySelector('[data-ov-popup-tags]');
//         if (tagsInput) tagsInput.value = 'newsletter, ' + answerLabel;
//       }
//     };
//     delayPopup.querySelectorAll('[data-ov-popup-answer]').forEach(function (btn) {
//       btn.addEventListener('click', function () {
//         goToForm(btn.getAttribute('data-ov-popup-answer'));
//       });
//     });
//     var skipBtn = delayPopup.querySelector('[data-ov-popup-skip]');
//     if (skipBtn) skipBtn.addEventListener('click', closePopup);
//   }

//   // Announcement bar — rotating messages + dismiss (remembered via localStorage)
//   var announceBar = document.querySelector('[data-ov-announce]');
//   if (announceBar) {
//     var dismissKey = 'ov-announce-dismissed';
//     var dismissed = false;
//     try { dismissed = window.localStorage.getItem(dismissKey) === '1'; } catch (e) {}
//     if (dismissed) {
//       announceBar.classList.add('is-dismissed');
//     } else {
//       var msgs = announceBar.querySelectorAll('[data-ov-announce-msg]');
//       if (msgs.length > 1) {
//         var activeIdx = 0;
//         var seconds = parseFloat(announceBar.getAttribute('data-rotate-seconds')) || 4;
//         setInterval(function () {
//           msgs[activeIdx].classList.remove('is-active');
//           activeIdx = (activeIdx + 1) % msgs.length;
//           msgs[activeIdx].classList.add('is-active');
//         }, seconds * 1000);
//       }
//       var closeBtn = announceBar.querySelector('[data-ov-announce-close]');
//       if (closeBtn) {
//         closeBtn.addEventListener('click', function () {
//           announceBar.classList.add('is-dismissed');
//           try { window.localStorage.setItem(dismissKey, '1'); } catch (e) {}
//         });
//       }
//     }
//   }

//   // Floating video widget -> expand modal
//   var vModal = document.querySelector('[data-ov-video-modal]');
//   var vWidget = document.querySelector('[data-ov-video-widget]');
//   if (vModal && vWidget) {
//     var widgetVideo = vWidget.querySelector('[data-ov-widget-video]');
//     var modalVideo = vModal.querySelector('[data-ov-modal-video]');

//     // Lock in the real aspect ratio (and only then fade the video in) once its
//     // metadata is known, so the bubble never flashes at a wrong size while
//     // width:170px/height:auto is guessing before the browser knows the ratio.
//     if (widgetVideo) {
//       var revealWidgetVideo = function () {
//         if (widgetVideo.videoWidth && widgetVideo.videoHeight) {
//           widgetVideo.style.aspectRatio = widgetVideo.videoWidth + ' / ' + widgetVideo.videoHeight;
//         }
//         widgetVideo.classList.add('is-ready');
//       };
//       if (widgetVideo.readyState >= 1) {
//         revealWidgetVideo();
//       } else {
//         widgetVideo.addEventListener('loadedmetadata', revealWidgetVideo, { once: true });
//       }
//     }
//     var openBtn = vWidget.querySelector('[data-ov-video-open]');
//     var closeEls = vModal.querySelectorAll('[data-ov-video-close]');
//     var unmuteBtn = vModal.querySelector('[data-ov-video-unmute]');
//     var unmuteLabel = vModal.querySelector('[data-ov-unmute-label]');

//     var openModal = function () {
//       vModal.classList.add('is-open');
//       document.body.style.overflow = 'hidden';
//       if (widgetVideo) widgetVideo.pause();
//       if (modalVideo) {
//         modalVideo.currentTime = widgetVideo ? widgetVideo.currentTime : 0;
//         modalVideo.play();
//       }
//     };
//     var closeModal = function () {
//       vModal.classList.remove('is-open');
//       document.body.style.overflow = '';
//       if (modalVideo) {
//         modalVideo.pause();
//         modalVideo.muted = true;
//         vModal.classList.remove('is-unmuted');
//         if (unmuteLabel) unmuteLabel.textContent = 'Unmute';
//       }
//       if (widgetVideo) widgetVideo.play();
//     };

//     if (openBtn) openBtn.addEventListener('click', openModal);
//     closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });
//     document.addEventListener('keydown', function (e) {
//       if (e.key === 'Escape' && vModal.classList.contains('is-open')) closeModal();
//     });
//     if (unmuteBtn) {
//       unmuteBtn.addEventListener('click', function () {
//         if (!modalVideo) return;
//         modalVideo.muted = !modalVideo.muted;
//         vModal.classList.toggle('is-unmuted', !modalVideo.muted);
//         if (unmuteLabel) unmuteLabel.textContent = modalVideo.muted ? 'Unmute' : 'Mute';
//       });
//     }
//   }

//   // Sticky add-to-cart bar
//   var stickyBar = document.querySelector('[data-ov-stickybar]');
//   if (stickyBar) {
//     var heroActions = document.querySelector('.ov-hero2__actions, .ov-hero__actions');
//     var videoWidgetEl = document.querySelector('[data-ov-video-widget]');
//     var barIsRaisingWidget = false;
//     var updateWidgetClearance = function () {
//       if (!videoWidgetEl) return;
//       videoWidgetEl.classList.toggle('is-raised', barIsRaisingWidget);
//       // Sticky bar height varies with viewport width (it wraps into two rows
//       // — title/note then price/qty/cta — at in-between screen widths), so
//       // clear it dynamically off the bar's real height rather than a fixed
//       // guess that only matched the single-row wide-desktop layout.
//       videoWidgetEl.style.bottom = barIsRaisingWidget ? (stickyBar.offsetHeight + 20) + 'px' : '';
//     };
//     if (heroActions && 'IntersectionObserver' in window) {
//       var stickyObserver = new IntersectionObserver(function (entries) {
//         entries.forEach(function (entry) {
//           var showBar = !entry.isIntersecting && entry.boundingClientRect.top < 0;
//           stickyBar.classList.toggle('is-visible', showBar);
//           barIsRaisingWidget = showBar;
//           updateWidgetClearance();
//         });
//       }, { threshold: 0 });
//       stickyObserver.observe(heroActions);
//       window.addEventListener('resize', function () {
//         if (barIsRaisingWidget) updateWidgetClearance();
//       });
//     }

//     var totop = stickyBar.querySelector('[data-ov-stickybar-totop]');
//     if (totop) {
//       totop.addEventListener('click', function () {
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//       });
//     }

//     var qtyInput = stickyBar.querySelector('[data-ov-qty-input]');
//     var qtyMinus = stickyBar.querySelector('[data-ov-qty-minus]');
//     var qtyPlus = stickyBar.querySelector('[data-ov-qty-plus]');
//     if (qtyInput && qtyMinus && qtyPlus) {
//       qtyMinus.addEventListener('click', function () {
//         var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
//         qtyInput.value = v;
//       });
//       qtyPlus.addEventListener('click', function () {
//         var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
//         qtyInput.value = v;
//       });
//     }

//     var addBtn = stickyBar.querySelector('[data-ov-sticky-add]');
//     if (addBtn) {
//       addBtn.addEventListener('click', function () {
//         if (addBtn.disabled) return;
//         var variantInput = document.getElementById('ov-variant-id');
//         var variantId = variantInput ? variantInput.value : null;
//         if (!variantId) return;
//         var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
//         var originalLabel = addBtn.textContent;
//         addBtn.dataset.originalLabel = originalLabel;
//         addBtn.disabled = true;
//         addBtn.textContent = 'Adding...';
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: quantity })
//         })
//           .then(function (res) {
//             if (!res.ok) return res.json().then(function (err) { throw err; });
//             return res.json();
//           })
//           .then(function () {
//             addBtn.textContent = 'Added!';
//             setTimeout(function () { window.location.href = '/cart'; }, 500);
//           })
//           .catch(function () {
//             addBtn.disabled = false;
//             addBtn.textContent = originalLabel;
//             alert('Could not add to cart. Please try again.');
//           });
//       });
//     }
//   }

//   // Nav "Buy Now" — adds the currently selected variant and jumps straight
//   // to checkout, instead of just scrolling to the plan selector. Only takes
//   // over when the link is still on its default #buy anchor (a merchant who
//   // has pointed it at a real custom URL is left alone).
//   document.querySelectorAll('[data-ov-nav-buynow]').forEach(function (btn) {
//     btn.addEventListener('click', function (e) {
//       if (btn.getAttribute('href') !== '#buy') return;
//       var variantInput = document.getElementById('ov-variant-id');
//       var variantId = variantInput ? variantInput.value : null;
//       if (!variantId || btn.classList.contains('is-loading')) return;
//       e.preventDefault();
//       btn.classList.add('is-loading');
//       var originalLabel = btn.textContent;
//       btn.dataset.originalLabel = originalLabel;
//       btn.textContent = 'Adding...';
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: 1 })
//       })
//         .then(function (res) {
//           if (!res.ok) return res.json().then(function (err) { throw err; });
//           return res.json();
//         })
//         .then(function () {
//           // window.location.href = '/checkout';

//           CashfreeOcc.initCheckout(btn);
//           btn.classList.remove('is-loading');
//           btn.textContent = originalLabel;
//         })
//         .catch(function () {
//           btn.classList.remove('is-loading');
//           btn.textContent = originalLabel;
//           alert('Could not proceed to checkout. Please try again.');
//         });
//     });
//   });

//   // Testimonials — auto-rotating single-statement carousel
//   var testiCarousel = document.querySelector('[data-ov-testimonial-carousel]');
//   if (testiCarousel) {
//     var testiSlides = testiCarousel.querySelectorAll('[data-ov-testimonial-slide]');
//     var testiDots = testiCarousel.querySelectorAll('[data-ov-testimonial-dot]');
//     var testiActive = 0;
//     var testiPaused = false;
//     var showTesti = function (i) {
//       testiActive = i;
//       testiSlides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
//       testiDots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
//     };
//     testiDots.forEach(function (dot, idx) {
//       dot.addEventListener('click', function () { showTesti(idx); });
//     });
//     testiCarousel.addEventListener('mouseenter', function () { testiPaused = true; });
//     testiCarousel.addEventListener('mouseleave', function () { testiPaused = false; });
//     setInterval(function () {
//       if (testiPaused || !testiSlides.length) return;
//       showTesti((testiActive + 1) % testiSlides.length);
//     }, 4000);
//   }

//   var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//   document.querySelectorAll('[data-ov-testi-marquee]').forEach(function (root) {
//     var track = root.querySelector('.ov-testi__track');
//     if (!track || reduceMotion) return;
//     var duration = parseFloat(getComputedStyle(root).getPropertyValue('--ov-testi-duration')) || 32;
//     var paused = false;
//     var resumeTimer = null;
//     var lastTs = null;

//     var pause = function () { paused = true; };
//     var resumeSoon = function () {
//       clearTimeout(resumeTimer);
//       resumeTimer = setTimeout(function () { paused = false; lastTs = null; }, 1500);
//     };

//     root.addEventListener('mouseenter', pause);
//     root.addEventListener('mouseleave', function () { clearTimeout(resumeTimer); paused = false; lastTs = null; });
//     root.addEventListener('touchstart', pause, { passive: true });
//     root.addEventListener('touchend', resumeSoon, { passive: true });
//     root.addEventListener('pointerdown', pause);
//     root.addEventListener('pointerup', resumeSoon);

//     var step = function (ts) {
//       if (!paused) {
//         if (lastTs == null) lastTs = ts;
//         var dt = (ts - lastTs) / 1000;
//         lastTs = ts;
//         var halfWidth = track.scrollWidth / 2;
//         if (halfWidth > 0) {
//           root.scrollLeft += (halfWidth / duration) * dt;
//           if (root.scrollLeft >= halfWidth) root.scrollLeft -= halfWidth;
//         }
//       } else {
//         lastTs = null;
//       }
//       requestAnimationFrame(step);
//     };
//     requestAnimationFrame(step);
//   });

//   // Steps (mobile) — auto-advancing single-slide carousel with dots
//   document.querySelectorAll('[data-ov-steps-mobile]').forEach(function (root) {
//     var slides = root.querySelectorAll('[data-ov-steps-mobile-slide]');
//     if (!slides.length) return;
//     var dotsWrap = root.parentElement.querySelector('[data-ov-steps-mobile-dots]');
//     var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-ov-steps-mobile-dot]') : [];
//     var autoscroll = root.getAttribute('data-ov-steps-autoscroll') === 'true';
//     var seconds = parseFloat(root.getAttribute('data-ov-steps-interval')) || 5;
//     var active = 0;
//     var paused = false;
//     var resumeTimer = null;

//     var show = function (i) {
//       active = (i + slides.length) % slides.length;
//       slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === active); });
//       dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === active); });
//     };

//     var advanceTimer = null;
//     var scheduleAdvance = function () {
//       clearTimeout(advanceTimer);
//       if (!autoscroll || reduceMotion) return;
//       advanceTimer = setTimeout(function () {
//         show(active + 1);
//         scheduleAdvance();
//       }, seconds * 1000);
//     };

//     var pauseNow = function () {
//       paused = true;
//       clearTimeout(advanceTimer);
//       clearTimeout(resumeTimer);
//     };

//     var pauseThenResume = function () {
//       pauseNow();
//       // Short pause after the user lets go, then resume with a fresh full
//       // interval — previously this waited a fixed 6s *plus* whatever was
//       // left on the old (never-reset) interval tick, so resuming could
//       // take up to ~11s and felt stuck.
//       resumeTimer = setTimeout(function () {
//         paused = false;
//         scheduleAdvance();
//       }, 2000);
//     };

//     dots.forEach(function (dot, idx) {
//       dot.addEventListener('click', function () { show(idx); pauseThenResume(); });
//     });

//     var touchStartX = null;
//     root.addEventListener('touchstart', function (e) {
//       touchStartX = e.touches[0].clientX;
//       pauseNow();
//     }, { passive: true });
//     root.addEventListener('touchend', function (e) {
//       if (touchStartX == null) return;
//       var dx = e.changedTouches[0].clientX - touchStartX;
//       if (Math.abs(dx) > 40) show(active + (dx < 0 ? 1 : -1));
//       touchStartX = null;
//       pauseThenResume();
//     }, { passive: true });

//     scheduleAdvance();
//   });

//   // Comparison table — offset scroll-snap by the sticky Feature column's
//   // real width, so columns snap flush against it instead of partway
//   // underneath the pinned overlay.
//   document.querySelectorAll('.ov-compare__wrap').forEach(function (wrap) {
//     var featureCol = wrap.querySelector('.ov-compare__th--feature');
//     if (!featureCol) return;
//     var syncPadding = function () {
//       wrap.style.scrollPaddingLeft = featureCol.offsetWidth + 'px';
//     };
//     syncPadding();
//     window.addEventListener('resize', syncPadding);
//   });
// });

// // Reset any "Adding..." / disabled buy buttons left mid-flight when the
// // browser restores this page from bfcache (e.g. hitting Back from checkout
// // or the cart) — otherwise they're stuck showing the loading state forever,
// // since that flow expected the visitor to leave the page for good.
// window.addEventListener('pageshow', function (e) {
//   if (!e.persisted) return;
//   document.querySelectorAll('[data-ov-sticky-add], [data-ov-nav-buynow]').forEach(function (btn) {
//     var original = btn.dataset.originalLabel;
//     if (original) btn.textContent = original;
//     btn.disabled = false;
//     btn.classList.remove('is-loading');
//   });
// });



document.addEventListener('DOMContentLoaded', function () {
  // Scroll reveal (fade + blur + rise) — ported from brahmaverse-one-website's <Reveal>
  var revealEls = document.querySelectorAll('[data-ov-reveal]');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px 220px 0px', threshold: 0.01 });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // Mobile nav toggle
  document.querySelectorAll('[data-ov-nav-toggle]').forEach(function (toggle) {
    var nav = toggle.closest('.ov-nav');
    if (!nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-menu-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    nav.querySelectorAll('.ov-nav__links a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  });

  // Accordions (notes list + FAQ)
  document.querySelectorAll('.ov-accordion__item').forEach(function (item) {
    var trigger = item.querySelector('.ov-accordion__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var group = item.closest('[data-accordion-group]');
      var exclusive = group && group.getAttribute('data-accordion-group') === 'single';
      if (exclusive) {
        group.querySelectorAll('.ov-accordion__item').forEach(function (sibling) {
          if (sibling !== item) sibling.classList.remove('is-open');
        });
      }
      item.classList.toggle('is-open');
    });
  });

  // Variant option swatches -> update hidden variant id + price
  document.querySelectorAll('[data-ov-option-value]').forEach(function (input) {
    input.addEventListener('change', updateOvVariant);
  });

  function updateOvVariant() {
    var form = document.getElementById('ov-product-form');
    if (!form) return;
    var script = form.closest('section').querySelector('script');
    if (!script) return;
    var match = script.textContent.match(/window\.ovProductVariants\[(.+?)\]\s*=\s*(\[.*\]);/s);
    if (!match) return;
    var variants;
    try { variants = JSON.parse(match[2]); } catch (e) { return; }

    var selected = [];
    form.querySelectorAll('[data-ov-option-index]').forEach(function (group) {
      var checked = group.querySelector('[data-ov-option-value]:checked');
      if (checked) selected.push(checked.value);
    });

    var found = variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return selected.every(function (val, i) { return opts[i] === val; });
    });
    if (!found) return;

    var idInput = document.getElementById('ov-variant-id');
    if (idInput) idInput.value = found.id;

    var priceEl = document.querySelector('[data-ov-price]');
    if (priceEl && found.price != null) {
      priceEl.textContent = (found.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD' });
    }

    var stickyPriceEl = document.querySelector('[data-ov-sticky-price]');
    if (stickyPriceEl && found.price != null) {
      stickyPriceEl.textContent = '₹' + Math.round(found.price / 100).toLocaleString('en-IN') + ' INR';
    }
  }

  // Hero gallery thumbnails
  document.querySelectorAll('[data-ov-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('[data-ov-gallery]');
      if (!gallery) return;
      var mainImg = gallery.querySelector('[data-ov-main-image]');
      var newSrc = thumb.getAttribute('data-full');
      if (mainImg && newSrc) mainImg.src = newSrc;
      gallery.querySelectorAll('[data-ov-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Hero v2 gallery prev/next arrows (no-op if a gallery has no arrows, e.g. the classic hero)
  document.querySelectorAll('[data-ov-gallery]').forEach(function (gallery) {
    var prevBtn = gallery.querySelector('[data-ov-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-ov-gallery-next]');
    if (!prevBtn && !nextBtn) return;
    var step = function (dir) {
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ov-thumb]'));
      if (!thumbs.length) return;
      var activeIndex = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      var nextIndex = (activeIndex + dir + thumbs.length) % thumbs.length;
      thumbs[nextIndex].click();
      thumbs[nextIndex].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
  });

  // Hero v2: cap the thumbnail rail's height to match the main image's real
  // rendered height (which varies with aspect-ratio + viewport width), so the
  // rail scrolls internally instead of running on past the bottom of the image.
  (function () {
    var rails = document.querySelectorAll('.ov-hero2__rail');
    if (!rails.length) return;
    var sync = function () {
      rails.forEach(function (rail) {
        var stage = rail.parentElement && rail.parentElement.querySelector('.ov-hero2__stage');
        if (!stage) return;
        if (window.matchMedia('(max-width: 980px)').matches) {
          rail.style.maxHeight = '';
        } else {
          rail.style.maxHeight = stage.offsetHeight + 'px';
        }
      });
    };
    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    var mainImg = document.querySelector('.ov-hero2__main-image img');
    if (mainImg && !mainImg.complete) mainImg.addEventListener('load', sync, { once: true });
  })();

  // Scroll-reveal heading — words dim→full opacity as the heading scrolls
  // through the viewport (ported from brahmaverse-one-website's ScrollRevealHeading)
  var scrollHeadings = document.querySelectorAll('[data-ov-scrollheading]');
  if (scrollHeadings.length) {
    var updateScrollHeadings = function () {
      var vh = window.innerHeight;
      scrollHeadings.forEach(function (h) {
        var rect = h.getBoundingClientRect();
        var p = (0.85 * vh - rect.top) / (0.5 * vh);
        p = Math.max(0, Math.min(1, p));
        var words = h.querySelectorAll('[data-ov-word]');
        var n = words.length;
        words.forEach(function (w, i) {
          var start = i / n, end = (i + 1) / n;
          var t = (p - start) / (end - start || 1);
          t = Math.max(0, Math.min(1, t));
          w.style.opacity = String(0.28 + t * 0.72);
        });
      });
    };
    window.addEventListener('scroll', updateScrollHeadings, { passive: true });
    window.addEventListener('resize', updateScrollHeadings);
    updateScrollHeadings();
  }

  // Ripple showcase — glass panels expand on hover/click, one open at a time
  document.querySelectorAll('[data-ov-glass-group]').forEach(function (group) {
    var panels = group.querySelectorAll('[data-ov-glass-panel]');
    var openOne = function (panel) {
      panels.forEach(function (p) { p.classList.toggle('is-open', p === panel); });
    };
    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { openOne(panel); });
      panel.addEventListener('click', function () { openOne(panel); });
    });
  });

  // Steps — scroll-pinned accordion (desktop). Section is 400vh tall; as the
  // user scrolls through it, the active step (0..3) tracks scroll position and
  // the phone screen cross-fades / device repositions to match.
  var stepsSection = document.querySelector('[data-ov-steps]');
  if (stepsSection) {
    var stepTabs = stepsSection.querySelectorAll('[data-ov-step-tab]');
    var stepScreens = stepsSection.querySelectorAll('[data-ov-step-screen]');
    var stepDevice = stepsSection.querySelector('[data-ov-step-device]');
    var stepPhone = stepsSection.querySelector('[data-ov-step-phone]');
    var stepRipple = stepsSection.querySelector('[data-ov-step-ripple]');
    var stepActive = 0;
    var setStepActive = function (i) {
      stepActive = i;
      stepTabs.forEach(function (tab, idx) { tab.classList.toggle('is-open', idx === i); });
      stepScreens.forEach(function (scr, idx) { scr.classList.toggle('is-visible', idx === i); });
      if (stepPhone) stepPhone.style.opacity = i === 0 ? '0.32' : '1';
      if (stepDevice) stepDevice.classList.toggle('is-behind', i !== 0);
      if (stepRipple) stepRipple.style.opacity = i === 0 ? '1' : '0';
    };
    stepTabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { setStepActive(idx); });
    });
    var updateSteps = function () {
      var rect = stepsSection.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      var p = scrollable > 0 ? Math.max(0, Math.min(1, -rect.top / scrollable)) : 0;
      var idx = Math.min(stepTabs.length - 1, Math.floor(p * stepTabs.length));
      if (idx !== stepActive) setStepActive(idx);
    };
    window.addEventListener('scroll', updateSteps, { passive: true });
    window.addEventListener('resize', updateSteps);
    setStepActive(0);
    updateSteps();
  }

  // Meet OneVerse — scroll-scrubbed device frame sequence pinned for 240vh
  var meetSection = document.querySelector('[data-ov-meet]');
  if (meetSection) {
    var meetCanvas = meetSection.querySelector('[data-ov-meet-canvas]');
    var meetHead = meetSection.querySelector('[data-ov-meet-head]');
    var meetTitle = meetSection.querySelector('.ov-meet__title');
    var meetSub = meetSection.querySelector('[data-ov-meet-sub]');
    var meetWords = meetSection.querySelectorAll('[data-ov-meet-word]');
    var FRAME_COUNT = 180, FRAME_W = 1080, FRAME_H = 2256, PAUSE_FRAME = 30;
    var PLAY1_START = 0.06, PLAY1_END = 0.24, SUB_START = 0.26, SUB_END = 0.48,
        RESUME_START = 0.5, RESUME_END = 0.92, EXIT_START = 0.82, EXIT_END = 0.94, HEAD_IN_END = 0.06;
    var clamp01 = function (v) { return Math.max(0, Math.min(1, v)); };
    var lerp = function (a, b, t) { return a + (b - a) * t; };
    var frameFor = function (p) {
      if (p <= PLAY1_START) return 0;
      if (p < PLAY1_END) return Math.round(((p - PLAY1_START) / (PLAY1_END - PLAY1_START)) * PAUSE_FRAME);
      if (p < RESUME_START) return PAUSE_FRAME;
      var t = (p - RESUME_START) / (RESUME_END - RESUME_START);
      return Math.round(PAUSE_FRAME + clamp01(t) * (FRAME_COUNT - 1 - PAUSE_FRAME));
    };
    var meetFramesScript = meetSection.querySelector('[data-ov-meet-frames]');
    var meetFrameUrls = [];
    try { meetFrameUrls = JSON.parse(meetFramesScript.textContent); } catch (e) { meetFrameUrls = []; }
    var meetImgs = [];
    for (var mi = 0; mi < FRAME_COUNT; mi++) {
      var im = new Image();
      im.decoding = 'async';
      im.src = meetFrameUrls[mi] || '';
      meetImgs.push(im);
    }
    var meetDraw = function (p) {
      if (!meetCanvas || !meetCanvas.getContext) return;
      var ctx = meetCanvas.getContext('2d');
      if (!ctx) return;
      var target = Math.min(FRAME_COUNT - 1, Math.max(0, frameFor(p)));
      var img = meetImgs[target];
      var ok = function (im) { return im && im.complete && im.naturalWidth > 0; };
      if (!ok(img)) {
        for (var d = 1; d < FRAME_COUNT; d++) {
          if (ok(meetImgs[target - d])) { img = meetImgs[target - d]; break; }
          if (ok(meetImgs[target + d])) { img = meetImgs[target + d]; break; }
        }
      }
      if (!ok(img)) return;
      var dpr = window.devicePixelRatio || 1;
      var cw = meetCanvas.clientWidth, ch = meetCanvas.clientHeight;
      if (meetCanvas.width !== Math.round(cw * dpr) || meetCanvas.height !== Math.round(ch * dpr)) {
        meetCanvas.width = Math.round(cw * dpr);
        meetCanvas.height = Math.round(ch * dpr);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, cw, ch);
      var aspect = cw / ch;
      var coverBias = aspect < 0.85 ? 0.32 : 0.55;
      var scaleCover = cw / FRAME_W, scaleContain = ch / FRAME_H;
      var scale = lerp(scaleContain, scaleCover, coverBias);
      var drawW = FRAME_W * scale, drawH = FRAME_H * scale;
      var dx = (cw - drawW) / 2;
      var deviceFrac = p < RESUME_START ? 0.05 : lerp(0.05, 0.42, clamp01((p - RESUME_START) / (RESUME_END - RESUME_START)));
      var dy = ch / 2 - deviceFrac * drawH;
      dy = Math.max(Math.min(0, ch - drawH), dy);
      ctx.drawImage(img, dx, dy, drawW, drawH);
    };
    var meetApplyText = function (p) {
      var intro = clamp01(p / HEAD_IN_END);
      var introEase = 1 - Math.pow(1 - intro, 3);
      var exit = clamp01((p - EXIT_START) / (EXIT_END - EXIT_START));
      if (meetHead) {
        meetHead.style.opacity = String(intro * (1 - exit));
        meetHead.style.transform = 'translate3d(0,' + (lerp(20, 0, introEase) - p * 22 - 140 * exit) + 'px,0)';
      }
      if (meetTitle) {
        meetTitle.style.letterSpacing = lerp(0.18, -0.025, introEase) + 'em';
        meetTitle.style.filter = 'blur(' + lerp(10, 0, introEase) + 'px)';
      }
      var span = (SUB_END - SUB_START) / meetWords.length;
      meetWords.forEach(function (el, k) {
        var start = SUB_START + k * span;
        var t = clamp01((p - start) / (span * 1.5));
        el.style.opacity = String(t);
        el.style.transform = 'translate3d(0,' + lerp(12, 0, t) + 'px,0)';
        el.style.filter = 'blur(' + lerp(6, 0, t) + 'px)';
      });
    };
    var meetCompute = function () {
      var rect = meetSection.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      var p = scrollable > 0 ? clamp01(-rect.top / scrollable) : 0;
      meetApplyText(p);
      meetDraw(p);
    };
    var meetRaf = 0;
    var meetOnScroll = function () {
      cancelAnimationFrame(meetRaf);
      meetRaf = requestAnimationFrame(meetCompute);
    };
    meetImgs.forEach(function (im) { im.onload = function () { meetDraw(progressNow()); }; });
    function progressNow() {
      var rect = meetSection.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      return scrollable > 0 ? clamp01(-rect.top / scrollable) : 0;
    }
    window.addEventListener('scroll', meetOnScroll, { passive: true });
    window.addEventListener('resize', meetOnScroll);
    meetCompute();
    setTimeout(meetCompute, 300);
    setTimeout(meetCompute, 1000);
  }

  // Delay popup — opens automatically after N seconds
  var delayPopup = document.querySelector('[data-ov-delaypopup]');
  if (delayPopup) {
    var popupSeenKey = 'ov-delaypopup-seen';
    var frequency = delayPopup.getAttribute('data-once-per') || 'session';
    var alreadySeen = false;
    try { alreadySeen = window.sessionStorage.getItem(popupSeenKey) === '1'; } catch (e) {}

    var openPopup = function () {
      delayPopup.classList.add('is-open');
      try { window.sessionStorage.setItem(popupSeenKey, '1'); } catch (e) {}
    };
    var closePopup = function () { delayPopup.classList.remove('is-open'); };

    if (frequency === 'always' || !alreadySeen) {
      var delaySeconds = parseFloat(delayPopup.getAttribute('data-delay-seconds')) || 15;
      setTimeout(openPopup, delaySeconds * 1000);
    }

    delayPopup.querySelectorAll('[data-ov-delaypopup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && delayPopup.classList.contains('is-open')) closePopup();
    });

    // Step 1 (question) -> step 2 (email form), tagging the pick onto the submission
    var goToForm = function (answerLabel) {
      var questionStep = delayPopup.querySelector('[data-ov-popup-step="question"]');
      var formStep = delayPopup.querySelector('[data-ov-popup-step="form"]');
      if (questionStep) questionStep.classList.remove('is-active');
      if (formStep) formStep.classList.add('is-active');
      if (answerLabel) {
        var tagsInput = delayPopup.querySelector('[data-ov-popup-tags]');
        if (tagsInput) tagsInput.value = 'newsletter, ' + answerLabel;
      }
    };
    delayPopup.querySelectorAll('[data-ov-popup-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToForm(btn.getAttribute('data-ov-popup-answer'));
      });
    });
    var skipBtn = delayPopup.querySelector('[data-ov-popup-skip]');
    if (skipBtn) skipBtn.addEventListener('click', closePopup);
  }

  // Announcement bar — rotating messages + dismiss (remembered via localStorage)
  var announceBar = document.querySelector('[data-ov-announce]');
  if (announceBar) {
    var dismissKey = 'ov-announce-dismissed';
    var dismissed = false;
    try { dismissed = window.localStorage.getItem(dismissKey) === '1'; } catch (e) {}
    if (dismissed) {
      announceBar.classList.add('is-dismissed');
    } else {
      var msgs = announceBar.querySelectorAll('[data-ov-announce-msg]');
      if (msgs.length > 1) {
        var activeIdx = 0;
        var seconds = parseFloat(announceBar.getAttribute('data-rotate-seconds')) || 4;
        setInterval(function () {
          msgs[activeIdx].classList.remove('is-active');
          activeIdx = (activeIdx + 1) % msgs.length;
          msgs[activeIdx].classList.add('is-active');
        }, seconds * 1000);
      }
      var closeBtn = announceBar.querySelector('[data-ov-announce-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          announceBar.classList.add('is-dismissed');
          try { window.localStorage.setItem(dismissKey, '1'); } catch (e) {}
        });
      }
    }
  }

  // Floating video widget -> expand modal
  var vModal = document.querySelector('[data-ov-video-modal]');
  var vWidget = document.querySelector('[data-ov-video-widget]');
  if (vModal && vWidget) {
    var widgetVideo = vWidget.querySelector('[data-ov-widget-video]');
    var modalVideo = vModal.querySelector('[data-ov-modal-video]');

    // Lock in the real aspect ratio (and only then fade the video in) once its
    // metadata is known, so the bubble never flashes at a wrong size while
    // width:170px/height:auto is guessing before the browser knows the ratio.
    if (widgetVideo) {
      var revealWidgetVideo = function () {
        if (widgetVideo.videoWidth && widgetVideo.videoHeight) {
          widgetVideo.style.aspectRatio = widgetVideo.videoWidth + ' / ' + widgetVideo.videoHeight;
        }
        widgetVideo.classList.add('is-ready');
      };
      if (widgetVideo.readyState >= 1) {
        revealWidgetVideo();
      } else {
        widgetVideo.addEventListener('loadedmetadata', revealWidgetVideo, { once: true });
      }
    }
    var openBtn = vWidget.querySelector('[data-ov-video-open]');
    var closeEls = vModal.querySelectorAll('[data-ov-video-close]');
    var unmuteBtn = vModal.querySelector('[data-ov-video-unmute]');
    var unmuteLabel = vModal.querySelector('[data-ov-unmute-label]');

    var openModal = function () {
      vModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (widgetVideo) widgetVideo.pause();
      if (modalVideo) {
        modalVideo.currentTime = widgetVideo ? widgetVideo.currentTime : 0;
        modalVideo.play();
      }
    };
    var closeModal = function () {
      vModal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.muted = true;
        vModal.classList.remove('is-unmuted');
        if (unmuteLabel) unmuteLabel.textContent = 'Unmute';
      }
      if (widgetVideo) widgetVideo.play();
    };

    if (openBtn) openBtn.addEventListener('click', openModal);
    closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && vModal.classList.contains('is-open')) closeModal();
    });
    if (unmuteBtn) {
      unmuteBtn.addEventListener('click', function () {
        if (!modalVideo) return;
        modalVideo.muted = !modalVideo.muted;
        vModal.classList.toggle('is-unmuted', !modalVideo.muted);
        if (unmuteLabel) unmuteLabel.textContent = modalVideo.muted ? 'Unmute' : 'Mute';
      });
    }
  }

  // Sticky add-to-cart bar
  var stickyBar = document.querySelector('[data-ov-stickybar]');
  if (stickyBar) {
    var heroActions = document.querySelector('.ov-hero2__actions, .ov-hero__actions');
    var videoWidgetEl = document.querySelector('[data-ov-video-widget]');
    var barIsRaisingWidget = false;
    var updateWidgetClearance = function () {
      if (!videoWidgetEl) return;
      videoWidgetEl.classList.toggle('is-raised', barIsRaisingWidget);
      // Sticky bar height varies with viewport width (it wraps into two rows
      // — title/note then price/qty/cta — at in-between screen widths), so
      // clear it dynamically off the bar's real height rather than a fixed
      // guess that only matched the single-row wide-desktop layout.
      videoWidgetEl.style.bottom = barIsRaisingWidget ? (stickyBar.offsetHeight + 20) + 'px' : '';
    };
    if (heroActions && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var showBar = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', showBar);
          barIsRaisingWidget = showBar;
          updateWidgetClearance();
        });
      }, { threshold: 0 });
      stickyObserver.observe(heroActions);
      window.addEventListener('resize', function () {
        if (barIsRaisingWidget) updateWidgetClearance();
      });
    }

    var totop = stickyBar.querySelector('[data-ov-stickybar-totop]');
    if (totop) {
      totop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    var qtyInput = stickyBar.querySelector('[data-ov-qty-input]');
    var qtyMinus = stickyBar.querySelector('[data-ov-qty-minus]');
    var qtyPlus = stickyBar.querySelector('[data-ov-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
      });
      qtyPlus.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = v;
      });
    }

    var addBtn = stickyBar.querySelector('[data-ov-sticky-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var variantInput = document.getElementById('ov-variant-id');
        var variantId = variantInput ? variantInput.value : null;
        if (!variantId) return;
        var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var originalLabel = addBtn.textContent;
        addBtn.dataset.originalLabel = originalLabel;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            addBtn.textContent = 'Added!';
            setTimeout(function () { window.location.href = '/cart'; }, 500);
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = originalLabel;
            alert('Could not add to cart. Please try again.');
          });
      });
    }
  }

  // Shared Buy Now -> OCC handler, used by both the nav "Buy Now" link and
  // the Shopify "Buy it now" dynamic checkout button. The nav link only takes
  // over when it is still on its default #buy anchor (a merchant who has
  // pointed it at a real custom URL is left alone).
  function ovBuyNow(btn, e) {
    if (btn.tagName === 'A' && btn.getAttribute('href') !== '#buy') return;
    var variantInput = document.getElementById('ov-variant-id');
    var variantId = variantInput ? variantInput.value : null;
    if (!variantId || btn.classList.contains('is-loading')) return;
    e.preventDefault();

    var qtyEl = document.querySelector('#ov-product-form [name="quantity"]');
    var quantity = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;

    btn.classList.add('is-loading');
    var originalLabel = btn.textContent;
    btn.dataset.originalLabel = originalLabel;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        CashfreeOcc.initCheckout(btn);
        btn.classList.remove('is-loading');
        btn.textContent = originalLabel;
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = originalLabel;
        alert('Could not proceed to checkout. Please try again.');
      });
  }

  // Nav "Buy Now"
  document.querySelectorAll('[data-ov-nav-buynow]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { ovBuyNow(btn, e); });
  });

  // Shopify "Buy it now" — rendered async inside <shopify-accelerated-checkout>,
  // so listen on window in capture phase and block Shopify's native handler.
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.shopify-payment-button__button');
    if (!btn) return;
    e.stopImmediatePropagation();
    ovBuyNow(btn, e);
  }, true);

  // Testimonials — auto-rotating single-statement carousel
  var testiCarousel = document.querySelector('[data-ov-testimonial-carousel]');
  if (testiCarousel) {
    var testiSlides = testiCarousel.querySelectorAll('[data-ov-testimonial-slide]');
    var testiDots = testiCarousel.querySelectorAll('[data-ov-testimonial-dot]');
    var testiActive = 0;
    var testiPaused = false;
    var showTesti = function (i) {
      testiActive = i;
      testiSlides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      testiDots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    };
    testiDots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { showTesti(idx); });
    });
    testiCarousel.addEventListener('mouseenter', function () { testiPaused = true; });
    testiCarousel.addEventListener('mouseleave', function () { testiPaused = false; });
    setInterval(function () {
      if (testiPaused || !testiSlides.length) return;
      showTesti((testiActive + 1) % testiSlides.length);
    }, 4000);
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-ov-testi-marquee]').forEach(function (root) {
    var track = root.querySelector('.ov-testi__track');
    if (!track || reduceMotion) return;
    var duration = parseFloat(getComputedStyle(root).getPropertyValue('--ov-testi-duration')) || 32;
    var paused = false;
    var resumeTimer = null;
    var lastTs = null;

    var pause = function () { paused = true; };
    var resumeSoon = function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; lastTs = null; }, 1500);
    };

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', function () { clearTimeout(resumeTimer); paused = false; lastTs = null; });
    root.addEventListener('touchstart', pause, { passive: true });
    root.addEventListener('touchend', resumeSoon, { passive: true });
    root.addEventListener('pointerdown', pause);
    root.addEventListener('pointerup', resumeSoon);

    var step = function (ts) {
      if (!paused) {
        if (lastTs == null) lastTs = ts;
        var dt = (ts - lastTs) / 1000;
        lastTs = ts;
        var halfWidth = track.scrollWidth / 2;
        if (halfWidth > 0) {
          root.scrollLeft += (halfWidth / duration) * dt;
          if (root.scrollLeft >= halfWidth) root.scrollLeft -= halfWidth;
        }
      } else {
        lastTs = null;
      }
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  });

  // Steps (mobile) — auto-advancing single-slide carousel with dots
  document.querySelectorAll('[data-ov-steps-mobile]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-ov-steps-mobile-slide]');
    if (!slides.length) return;
    var dotsWrap = root.parentElement.querySelector('[data-ov-steps-mobile-dots]');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-ov-steps-mobile-dot]') : [];
    var autoscroll = root.getAttribute('data-ov-steps-autoscroll') === 'true';
    var seconds = parseFloat(root.getAttribute('data-ov-steps-interval')) || 5;
    var active = 0;
    var paused = false;
    var resumeTimer = null;

    var show = function (i) {
      active = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === active); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === active); });
    };

    var advanceTimer = null;
    var scheduleAdvance = function () {
      clearTimeout(advanceTimer);
      if (!autoscroll || reduceMotion) return;
      advanceTimer = setTimeout(function () {
        show(active + 1);
        scheduleAdvance();
      }, seconds * 1000);
    };

    var pauseNow = function () {
      paused = true;
      clearTimeout(advanceTimer);
      clearTimeout(resumeTimer);
    };

    var pauseThenResume = function () {
      pauseNow();
      // Short pause after the user lets go, then resume with a fresh full
      // interval — previously this waited a fixed 6s *plus* whatever was
      // left on the old (never-reset) interval tick, so resuming could
      // take up to ~11s and felt stuck.
      resumeTimer = setTimeout(function () {
        paused = false;
        scheduleAdvance();
      }, 2000);
    };

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { show(idx); pauseThenResume(); });
    });

    var touchStartX = null;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      pauseNow();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchStartX == null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) show(active + (dx < 0 ? 1 : -1));
      touchStartX = null;
      pauseThenResume();
    }, { passive: true });

    scheduleAdvance();
  });

  // Comparison table — offset scroll-snap by the sticky Feature column's
  // real width, so columns snap flush against it instead of partway
  // underneath the pinned overlay.
  document.querySelectorAll('.ov-compare__wrap').forEach(function (wrap) {
    var featureCol = wrap.querySelector('.ov-compare__th--feature');
    if (!featureCol) return;
    var syncPadding = function () {
      wrap.style.scrollPaddingLeft = featureCol.offsetWidth + 'px';
    };
    syncPadding();
    window.addEventListener('resize', syncPadding);
  });
});

// Reset any "Adding..." / disabled buy buttons left mid-flight when the
// browser restores this page from bfcache (e.g. hitting Back from checkout
// or the cart) — otherwise they're stuck showing the loading state forever,
// since that flow expected the visitor to leave the page for good.
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  document.querySelectorAll('[data-ov-sticky-add], [data-ov-nav-buynow], .shopify-payment-button__button').forEach(function (btn) {
    var original = btn.dataset.originalLabel;
    if (original) btn.textContent = original;
    btn.disabled = false;
    btn.classList.remove('is-loading');
  });
});